import clsx from 'clsx';

interface CardSkeletonProps {
  cardBody?: boolean;
}

const CardSkeleton = ({ cardBody }: CardSkeletonProps) => (
  <div className="px-4 py-3 md:min-h-[120px] animate-pulse w-full">
    <div className="flex justify-between h-100 flex-wrap">
      <div className={clsx('w-7/12', cardBody ? 'auto' : 'h-100')}>
        <div className="md:h-[20px] h-[15px] bg-gray-300 w-2/3 mb-2.5" />
        <div className="md:h-[55px] h-[35px] mt-3 bg-gray-200" />
      </div>
      <div className="md:h-[35px] h-[25px] bg-gray-300 w-4/12" />
      {cardBody && (
        <div className="md:h-[240px] h-[150px] bg-gray-300 w-full mt-3" />
      )}
    </div>
  </div>
);

export default CardSkeleton;
